<script setup lang="ts">
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { RefreshCcw } from 'lucide-vue-next'
import { useRegisterSW } from 'virtual:pwa-register/vue'
import { ref, watch } from 'vue'
import Button from './ui/button/Button.vue'

const { needRefresh, updateServiceWorker } = useRegisterSW()

const showRefreshButton = ref(false)

watch(needRefresh, (ready) => {
  showRefreshButton.value = ready
})

const onRefreshClick = async () => {
  await updateServiceWorker()
  location.reload()
}
</script>

<template>
  <Alert class="mb-6" v-if="showRefreshButton">
    <RefreshCcw class="mt-1" />

    <AlertTitle class="text-xl"> New Update Available! </AlertTitle>

    <AlertDescription class="text-base">
      A new version of the app is available. Click the button below to refresh the app and get the
      latest features and fixes.
      <div class="flex gap-2 mt-2">
        <Button @click="onRefreshClick" class="bg-green-600 hover:bg-green-700 cursor-pointer">
          Refresh
        </Button>
      </div>
    </AlertDescription>
  </Alert>
</template>
